export default "__VITE_ASSET__CTi0FdaJ__"